import React from 'react';
import '../../css/designSystem/FilledButton.css';

const FilledButton = ({ text, onClick }) => {
  return (
    <button className="filled-button" onClick={onClick}>
      <div className='help-text'>{text} </div>
    </button>
  );  
};

export default FilledButton;